import React from "react";

/**
 * Real-time "Hot Lot" pulse badge.
 *
 * Renders nothing for "cold", a calm dot+count for "active", a glowing
 * fire pill for "hot", and a screen-shaking frenzy banner for "frenzy".
 * Server emits `lot.heat` WS events on tier transitions; the parent
 * passes the current level + optional 5s-window bid count.
 */
export default function HotLotBadge({ level = "cold", bids5s = 0, compact = false }) {
  if (!level || level === "cold") return null;

  if (level === "active") {
    return (
      <span
        data-testid="hot-lot-badge-active"
        className="inline-flex items-center gap-1 rounded-full bg-zinc-700/70 text-zinc-100 px-1.5 py-0.5 text-[10px] font-bold tracking-tight"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-green-400 animate-pulse" />
        Heating up
      </span>
    );
  }

  if (level === "hot") {
    return (
      <span
        data-testid="hot-lot-badge-hot"
        className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-orange-500 to-rose-500 text-white px-2 py-0.5 text-[10px] font-black tracking-wider shadow-lg shadow-rose-500/30 hot-lot-pulse"
      >
        <span aria-hidden>🔥</span>
        HOT LOT
        {!compact && bids5s > 0 && (
          <span className="ml-0.5 opacity-90">{bids5s}/5s</span>
        )}
      </span>
    );
  }

  // frenzy
  return (
    <span
      data-testid="hot-lot-badge-frenzy"
      className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-red-600 via-rose-500 to-amber-400 text-white px-2.5 py-1 text-[11px] font-black tracking-widest uppercase shadow-2xl shadow-rose-500/50 hot-lot-frenzy"
    >
      <span aria-hidden className="animate-bounce">🔥</span>
      FRENZY
      {!compact && bids5s > 0 && (
        <span className="ml-0.5 opacity-90">{bids5s}/5s</span>
      )}
    </span>
  );
}
